"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getContentType_1 = require("../helpers/getContentType");
const validateUser_1 = require("../helpers/validateUser");
const entity_1 = require("../type/entity");
const evaluateChannelCard_1 = require("./evaluateChannelCard");
const evaluateCheckpoint_1 = require("./evaluateCheckpoint");
const evaluateCurriculum_1 = require("./evaluateCurriculum");
const evaluateILT_1 = require("./evaluateILT");
const evaluateOffer_1 = require("./evaluateOffer");
function evaluate(command, user, content, states) {
    validateUser_1.validateUser(user, { command, caller: 'evaluate' });
    const events = [];
    let updatedStates = states;
    const contentType = getContentType_1.getContentType(content);
    let evaluationPayload;
    switch (contentType) {
        case entity_1.ContentType.COURSE:
            evaluationPayload = evaluateOffer_1.evaluateOffer(command, user, content, updatedStates);
            events.push(...evaluationPayload.events);
            updatedStates = evaluationPayload.states;
            break;
        case entity_1.ContentType.CURRICULUM:
            evaluationPayload = evaluateCurriculum_1.evaluateCurriculum(command, user, content, updatedStates);
            events.push(...evaluationPayload.events);
            updatedStates = evaluationPayload.states;
            break;
        case entity_1.ContentType.CHECKPOINT:
            evaluationPayload = evaluateCheckpoint_1.evaluateCheckpoint(command, user, content, updatedStates);
            events.push(...evaluationPayload.events);
            updatedStates = evaluationPayload.states;
            break;
        case entity_1.ContentType.ILT:
            evaluationPayload = evaluateILT_1.evaluateILT(command, user, content, updatedStates);
            events.push(...evaluationPayload.events);
            updatedStates = evaluationPayload.states;
            break;
        case entity_1.ContentType.CHANNEL_CARD:
            evaluationPayload = evaluateChannelCard_1.evaluateChannel(command, user, content, updatedStates);
            events.push(...evaluationPayload.events);
            updatedStates = evaluationPayload.states;
            break;
        default:
            console.info('Incorrect content type found in evaluate', contentType);
    }
    return { events, states: updatedStates, stateInteractions: [] };
}
exports.evaluate = evaluate;
//# sourceMappingURL=index.js.map